// extracted by mini-css-extract-plugin
module.exports = {"list":"Chip_list__3tRlv","container":"Chip_container__bqPdO","chip":"Chip_chip__ry4NQ","img":"Chip_img__G06VD","title":"Chip_title__tZMgw"};